'use es6';

import { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getUsageTracker } from '../../utils/usageTracker';

const UsageViewTracker = ({
  active = true,
  eventName = 'pageView',
  eventProperties = {},
  onTrackView
}) => {
  const [tracked, setTracked] = useState(false);
  const getComputedEventProperties = useCallback(() => {
    return typeof eventProperties === 'function' ? eventProperties() : eventProperties;
  }, [eventProperties]);
  const trackView = useCallback(() => {
    if (onTrackView) {
      onTrackView(getComputedEventProperties());
    } else {
      getUsageTracker().track(eventName, getComputedEventProperties());
    }
  }, [eventName, getComputedEventProperties, onTrackView]);
  useEffect(() => {
    if (active && !tracked) {
      trackView();
      setTracked(true);
    }
  }, [active, trackView, tracked]);
  return null;
};

UsageViewTracker.propTypes = {
  active: PropTypes.bool,
  eventName: PropTypes.string,
  eventProperties: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
  onTrackView: PropTypes.func
};
export default UsageViewTracker;